import Parse from "parse";

import type { Category } from "./Category";

type OD3_Language = Parse.Object;
type OD3_Tenant = Parse.Object;

export interface DocumentAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  category: Category;
  document: Parse.File;
  label: string;
  language: OD3_Language;
  tenant: OD3_Tenant;
}

export class Document extends Parse.Object<DocumentAttributes> {
  static className: string = "OD3_Knowledge_Document";

  constructor(data?: Partial<DocumentAttributes>) {
    super("OD3_Knowledge_Document", data as DocumentAttributes);
  }

  get category(): Category {
    return super.get("category");
  }
  set category(value: Category) {
    super.set("category", value);
  }
  get document(): Parse.File {
    return super.get("document");
  }
  set document(value: Parse.File) {
    super.set("document", value);
  }
  get label(): string {
    return super.get("label");
  }
  set label(value: string) {
    super.set("label", value);
  }
  get language(): OD3_Language {
    return super.get("language");
  }
  set language(value: OD3_Language) {
    super.set("language", value);
  }
  get tenant(): OD3_Tenant {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant) {
    super.set("tenant", value);
  }
}

Parse.Object.registerSubclass("OD3_Knowledge_Document", Document);
